var reduxActions = {
    // Account actions
    UPDATE_APPLICATION_ACCOUNT: 'UPDATE_APPLICATION_ACCOUNT',
    RESET_APPLICATION_ACCOUNT: 'RESET_APPLICATION_ACCOUNT',

    // FAQ actions
    ADD_FAQ_ITEM: 'ADD_FAQ_ITEM',
    RESET_FAQ: 'RESET_FAQ',

    // Nav actions
    MENU_TOGGLE: 'MENU_TOGGLE',

    // Route actions
    STATE_CHANGE: 'STATE_CHANGE',

    // Registration actions
    SET_REGISTRATION_PAGE: 'SET_REGISTRATION_PAGE',
    RESET_REGISTRATION_PAGE: 'RESET_REGISTRATION_PAGE',
    REGISTRATION_START: 'REGISTRATION_START',
    REGISTRATION_SUCCEEDED: 'REGISTRATION_SUCCEEDED',
    REGISTRATION_FAILED: 'REGISTRATION_FAILED',

    // Verification actions
    VERIFY_START: 'VERIFY_START',
    VERIFY_SUCCEEDED: 'VERIFY_SUCCEEDED',
    VERIFY_FAILED: 'VERIFY_FAILED',
    UPDATE_USER_APPROVAL_STATUS: 'UPDATE_USER_APPROVAL_STATUS',

    // Login actions
    LOGIN_START: 'LOGIN_START',
    LOGIN_SUCCEEDED: 'LOGIN_SUCCEEDED',
    LOGIN_FAILED: 'LOGIN_FAILED',
    SET_SESSION: 'SET_SESSION',
    END_SESSION: 'END_SESSION',
    SCHEDULE_TOKEN_REFRESH: 'SCHEDULE_TOKEN_REFRESH',
    CANCEL_TOKEN_REFRESH: 'CANCEL_TOKEN_REFRESH',

    // Resource actions
    RESOURCE_FETCH: 'RESOURCE_FETCH',
    RESOURCE_FETCH_SUCCESS: 'RESOURCE_FETCH_SUCCESS',
    RESOURCE_FETCH_FAIL: 'RESOURCE_FETCH_FAIL',
    RESOURCE_RESET: 'RESOURCE_RESET',
    RESOURCE_SET_SEARCH_PARAMS: 'RESOURCE_SET_SEARCH_PARAMS',

    USER_MANAGEMENT_APPROVE: 'USER_MANAGEMENT_APPROVE',
    USER_MANAGEMENT_REJECT: 'USER_MANAGEMENT_REJECT',
    USER_MANAGEMENT_SET_TAB_STATE: 'USER_MANAGEMENT_SET_TAB_STATE',

    // Growl actions
    ADD_GROWL: 'ADD_GROWL',
    REMOVE_GROWL: 'REMOVE_GROWL',
    DELAY_GROWL: 'DELAY_GROWL',
    REMOVE_ALL_GROWLS: 'REMOVE_ALL_GROWLS'
}

export default reduxActions;



// WEBPACK FOOTER //
// ./web-app/constants/redux-actions.js